import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    currency_list:[],
    list:{},
    lists:[],
    total_count:'',
    count:'',
    status_code:'',
  status_message:'',
  status_type:''
}
const mutations ={

  MESSAGE_RESULT(state, message) {
    state.message = message;
  },
  SET_VALUE(state, data) {
    state.list = data.data;
  },
  STATUS_CODE(state, code) {
    state.code = code;
  },
  LIST_DETAILS(state, data) {
    state.currency_list = data.currency_list;
  },
  GET_LIST(state, lists) {
    state.lists = lists.bank_list;
    state.total_count = lists.total_count;
    state.count = lists.show;
  },
  SET_CODE(state, data) {
    state.status_code = data.code;
    state.status_message = data.status;
    state.status_type = data.type;
  },
}

const actions = {
  bankingdelete({
    commit,
    rootState
  }, id) {
    return AppService.banking
      .postBankingdelete(id, rootState.session.token)
      .then((response) => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
      } else if (response.data.code != 404) {
          commit("SET_CODE", response.data);
          commit("SET_DATAS", response.data.data); // getting all the list in the api call
      } else {
          commit("SET_CODE", response.data);
      }
          return response
          
        
      })
      .catch((error) => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  bankingstatus({
    commit,
    rootState
  }, data) {
    return AppService.banking
      .postBankingstatus(data, rootState.session.token)
      .then((response) => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit("STATUS_CODE", response.status);
          return response
        }
      })
      .catch((error) => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  fetchBankingList({
    commit,
    rootState
  },{page,show}) {
    return AppService.banking
      .fetchBankingList(page,show, rootState.session.token)
      .then((response) => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit("GET_LIST", response.data.data); // getting all the list in the api call

        }
      })
      .catch((error) => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  fetchList({
    commit,
    rootState
  },id) {
    return AppService.banking
      .fetchBankingData(id, rootState.session.token)
      .then((response) => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit("SET_VALUE", response.data); // getting all the list in the api call

        }
      })
      .catch((error) => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  fetchBankingDetails({
    commit,
    rootState
  }) {
    return AppService.banking
      .getBankingDetails( rootState.session.token)
      .then((response) => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("LIST_DETAILS", response.data); // getting all the list in the api call

        }
      })
      .catch((error) => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },

  createList({
    commit,
    rootState
  }, data) {
    return AppService.banking
      .postBankAccount(data, rootState.session.token)
      .then((response) => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit("MESSAGE_RESULT", response.data); // getting all the list in the api call
         return response
        }
      })
      .catch((error) => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  updateList({
    commit,
    rootState
  }, {
    id,
    data
  }) {
    return AppService.banking
      .updateBankAccount(data, id, rootState.session.token)
      .then((response) => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit("MESSAGE_RESULT", response.data); // getting all the list in the api call
         return response
        }
      })
      .catch((error) => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
    
}
export default {
    namespaced,
    state,
    mutations,
    actions
}